import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import ReactCountdown from 'react-countdown'
import get from 'lodash/get'
import Banner from 'components/molecules/Banner'
import Typography from 'components/atoms/Typography'
import Image from 'components/atoms/Image'
import { userCheckMobileScreen } from 'helpers/tools'

import './Countdown.scss'

function Countdown({ data }) {
  const isMobile = userCheckMobileScreen()

  return (
    <div className="countdowm pb-5 pt-3" style={{ backgroundColor: get(data, 'background_color.color') }}>
      <Container>
        <Row className="d-flex flex-column-reverse flex-lg-row">
          <Col lg={5}>
            <Banner className="countdown__banner w-100" theme={get(data, 'theme.entity.classes')}>
              <ReactCountdown
                date={parseInt(get(data, 'datetime')) * 1000}
                renderer={(props) => (
                  <div className="d-flex flex-column justify-content-center countdown__clock">
                    <Typography cssClass="title-bold-md mb-2 countdown__title" color="white">
                      {get(data, 'title')}
                    </Typography>
                    <div className="d-flex">
                      <div className="d-flex flex-column align-items-center mr-4 countdown__item">
                        <Typography as="span" cssClass="countdown__date m-3">
                          {props.formatted.days}
                        </Typography>
                        <span className="countdown__description">Dias</span>
                      </div>
                      <div className="d-flex flex-column align-items-center countdown__item">
                        <Typography as="span" cssClass="countdown__date m-3">
                          {props.formatted.hours}:
                        </Typography>
                        <span className="countdown__description">Horas</span>
                      </div>
                      <div className="d-flex flex-column align-items-center countdown__item">
                        <Typography as="span" cssClass="countdown__date m-3">
                          {props.formatted.minutes}:
                        </Typography>
                        <span className="countdown__description">Min</span>
                      </div>
                      <div className="d-flex flex-column align-items-center countdown__item">
                        <Typography as="span" cssClass="countdown__date m-3">
                          {props.formatted.seconds}
                        </Typography>
                        <span className="countdown__description">Seg</span>
                      </div>
                    </div>
                  </div>
                )}
              />
            </Banner>
          </Col>
          <Col lg={7}>
            <Image
              alt={get(data, 'media.entity.images.alt')}
              className="countdown__media w-100"
              src={isMobile ? get(data, 'media.entity.images.medium.url') : get(data, 'media.entity.images.wide.url')}
            />
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default Countdown
